import { useIntl } from "react-intl";

type ToolsSectionListItem = {
  id: string;
  toolItemTitle: string;
  toolItemDescription: string;
  toolItemImageSrc: string;
};

const useToolsSectionList = (): ToolsSectionListItem[] => {
  const intl = useIntl();

  return [
    {
      id: "calendar-sync",
      toolItemTitle: intl.formatMessage({ defaultMessage: "Calendar sync" }),
      toolItemDescription: intl.formatMessage({
        defaultMessage: "Connect Google Calendar, iCal, or Outlook.",
      }),
      toolItemImageSrc:
        "https://img.peerspace.com/image/upload/c_fill,g_auto,w_720,h_720,f_auto,q_auto/v1780512812/host_page/tools_1",
    },
    {
      id: "guaranteed-payouts",
      toolItemTitle: intl.formatMessage({
        defaultMessage: "Guaranteed payouts",
      }),
      toolItemDescription: intl.formatMessage({
        defaultMessage: "We handle all payments and guarantee your payout.",
      }),
      toolItemImageSrc:
        "https://img.peerspace.com/image/upload/c_fill,g_auto,w_720,h_720,f_auto,q_auto/v1780512812/host_page/tools_2",
    },
    {
      id: "mobile-app",
      toolItemTitle: intl.formatMessage({ defaultMessage: "Mobile app" }),
      toolItemDescription: intl.formatMessage({
        defaultMessage: "Manage your listings from anywhere.",
      }),
      toolItemImageSrc:
        "https://img.peerspace.com/image/upload/c_fill,g_auto,w_720,h_720,f_auto,q_auto/v1780512812/host_page/tools_3",
    },
    {
      id: "host-hub",
      toolItemTitle: intl.formatMessage({ defaultMessage: "Host hub" }),
      toolItemDescription: intl.formatMessage({
        defaultMessage: "Metrics, bookings, messages—all in one.",
      }),
      toolItemImageSrc:
        "https://img.peerspace.com/image/upload/c_fill,g_auto,w_720,h_720,f_auto,q_auto/v1780512812/host_page/tools_4",
    },
    {
      id: "video-tour",
      toolItemTitle: intl.formatMessage({ defaultMessage: "Video & 3D tours" }),
      toolItemDescription: intl.formatMessage({
        defaultMessage: "Give guests an immersive preview.",
      }),
      toolItemImageSrc:
        "https://img.peerspace.com/image/upload/c_fill,g_auto,w_720,h_720,f_auto,q_auto/v1780512812/host_page/tools_5",
    },
    {
      id: "unified-inbox",
      toolItemTitle: intl.formatMessage({ defaultMessage: "Unified inbox" }),
      toolItemDescription: intl.formatMessage({
        defaultMessage: "Every guest conversation in one place.",
      }),
      toolItemImageSrc:
        "https://img.peerspace.com/image/upload/c_fill,g_auto,w_720,h_720,f_auto,q_auto/v1780512812/host_page/tools_6",
    },
  ];
};

export { useToolsSectionList };
